import { z } from 'zod'
import type { StagingAccountActivation } from '../../models/StagingAccountActivation'

export const StagingAccountActivationDTO = z.object({
  is_available: z.boolean(),
  is_activated: z.boolean()
})

export type StagingAccountActivationDTO = z.infer<typeof StagingAccountActivationDTO>

export const StagingAccountActivationResponseDTO = z.object({
  data: StagingAccountActivationDTO
})

export function mapDTOToStagingAccountActivation (dto: StagingAccountActivationDTO): StagingAccountActivation {
  return {
    isAvailable: dto.is_available,
    isActivated: dto.is_activated
  }
}
